// src/modules/app-views/crm/components/CardHeaderIcons.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import useZustand from 'hooks/useZustand';
import CardHeaderTeamMembers from 'layouts/Pages/PageHeader/CardHeaderTeamMembers';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CrmCardHeaderIcons = ({ consultantId }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const storedSubscription = useZustand('auth', 'subscription');

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. LOCAL VARIABLES
  // ─────────────────────────────────────────────────────────────────────────────
  if (!consultantId) return null;

  const team = storedSubscription?.team || [];
  const consultant = team.find(
    m => (m._id || m.accountId) === consultantId
  );

  if (!consultant) return null;

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <CardHeaderTeamMembers team={[consultant]} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CrmCardHeaderIcons;
